import { render, staticRenderFns } from "./TableCopies.vue?vue&type=template&id=567a66af&"
import script from "./TableCopies.vue?vue&type=script&lang=js&"
export * from "./TableCopies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567a66af')) {
      api.createRecord('567a66af', component.options)
    } else {
      api.reload('567a66af', component.options)
    }
    module.hot.accept("./TableCopies.vue?vue&type=template&id=567a66af&", function () {
      api.rerender('567a66af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/TableCopies.vue"
export default component.exports